export const onCallLinks = {
	'on-call-schedules-empty-state': {
		iphId: '7KkB6nTIcLcVRC2T39y2xI',
		sacUrl:
			'https://support.atlassian.com/jira-service-management-cloud/docs/how-do-on-call-schedules-work-in-operations/',
	},
};
